import { render, staticRenderFns } from "./ActiveGame.vue?vue&type=template&id=45c1a00a&"
import script from "./ActiveGame.vue?vue&type=script&lang=ts&"
export * from "./ActiveGame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports